module.exports = __webpack_public_path__ + "static/media/btn_feedback_1075_725.ffe19e4f.png";